import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#222",
      d: "M9 11.681a.8.8 0 0 1-.281-.046.65.65 0 0 1-.244-.16l-2.7-2.7a.69.69 0 0 1-.216-.525.8.8 0 0 1 .216-.525.76.76 0 0 1 .535-.234.7.7 0 0 1 .534.215L8.25 9.113V3.75q0-.318.216-.534A.73.73 0 0 1 9 3q.319 0 .535.216a.72.72 0 0 1 .215.534v5.363l1.406-1.407a.7.7 0 0 1 .535-.216.76.76 0 0 1 .534.235q.207.225.216.525a.69.69 0 0 1-.216.525l-2.7 2.7a.7.7 0 0 1-.244.16.8.8 0 0 1-.281.046M4.5 15q-.618 0-1.059-.44A1.45 1.45 0 0 1 3 13.5V12q0-.319.216-.534a.73.73 0 0 1 .534-.216q.318 0 .535.216A.72.72 0 0 1 4.5 12v1.5h9V12q0-.319.216-.534a.73.73 0 0 1 .534-.216q.319 0 .535.216A.72.72 0 0 1 15 12v1.5q0 .619-.44 1.06a1.44 1.44 0 0 1-1.06.44z"
    }, null, -1)
  ]))]))
}
export default { render: render }